export default __webpack_public_path__ + "static/media/congrats.bfee692d.gif";